<template>
  <!-- Card lado direito -->
  <div class='col-5 pr-3 py-3 d-none d-md-flex'>
    <section>
      <div class='card mb-3'>
        <div class='card-header card-chart-medium'>
          <span v-text="$ml.get('summaryCard')">Resumo dos relatórios</span>
          <div class='chart mt-4'>
            <canvas id='chart-financeiro'></canvas>
          </div>
        </div> 
        <div class='card-body card-chart-body pb-0 pt-1 d-flex flex-column justify-content-left'>
          <div class='row'>
            <div class='col-12 border-r-d mt-2 mb-2'>
              <span class='pb-1' v-text="$ml.get('pending')">Pendentes</span>
              <h6>{{ pending_amount }}</h6>
            </div>
            <div class='col-12 pl-3 mt-2 mb-2'>
              <span class='pb-1'>Total <font v-text="$ml.get('pending')"></font> </span>
              <h6>{{ $utils.convertMoney(pending_total) }}</h6>
            </div>
          </div>
          <hr class="w-100 m-0" />
          <div class='row'>
            <div class='col-12 border-r-d mt-2 mb-2'>
              <span class='pb-1' v-text="$ml.get('done')">Pago</span>
              <h6>{{ paid_amount }}</h6>
            </div>
            <div class='col-12 pl-3 mt-2 mb-2'>
              <span class='pb-1'>Total <font v-text="$ml.get('done')"></font> </span>
              <h6>{{ $utils.convertMoney(paid_total) }}</h6>
            </div>
          </div>
          <hr class="w-100 m-0" />
          <div class='row'>
            <div class='col-12 border-r-d mt-2 mb-2' style="color: #730BA9;">
              <span class='pb-1'>Total</span>
              <h6>{{ general_amount }}</h6>
            </div>
            <div class='col-12 pl-3 mt-2 mb-2' style="color: #730BA9;">
              <span class='pb-1'>Total</span>
              <h6>{{ $utils.convertMoney(general_total) }}</h6>
            </div>
          </div>
          <!-- font-size: 0.8rem; -->
          <label class="text-right pt-1">
            <small class="text-muted">*{{ $ml.get('taxesNotIncluded') }}</small>
          </label>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Chart from "chart.js";
import CompanyService from "../../../services/company.service";

export default {
  name:'CardExtract',
  data() {
    return {

      general_amount: 0,
      general_total: 0,

      paid_amount: 0,
      paid_total: 0,

      pending_amount: 0,
      pending_total: 0, 
    };
  },

  mounted() {
    this.changeExtractSummary(); 
  },
  methods: {

    changeExtractSummary() {

      CompanyService.getBountiesSummary().then(
        (response) => {

          this.general_amount = response.data.general_amount
          this.general_total = response.data.general_total

          this.paid_amount = response.data.paid_amount
          this.paid_total = response.data.paid_total;

          this.pending_amount = response.data.pending_amount
          this.pending_total = response.data.pending_total;

          this.loadChart();
        }
      );
    },
  
    loadChart() {
      var ctxFinanceiro = document.getElementById('chart-financeiro').getContext('2d');
      new Chart(ctxFinanceiro, {
        // The type of chart we want to create
        type: 'doughnut',

        // The data for our dataset
        data: {
          labels: ['Pagamentos efetuados', 'Pagamentos pendentes'],
          datasets: [
            {
              label: '',
              backgroundColor: ['RGB(214, 241, 214)', 'RGB(255, 177, 194)'],
              borderColor: ['RGB(167, 231, 175)', 'RGB(255, 138, 162)'],
              data: [this.paid_amount, this.pending_amount],
              pointBackgroundColor: ['transparent', 'transparent'],
              pointBorderColor: ['transparent', 'transparent'],
              pointBorderWidth: 0,
              borderWidth: 1,
              pointRadius: 0,

            }

          ]
        },

        // Configuration options go here
        options: {
          responsive: true,
          maintainAspectRatio: false,
          spanGaps: false,
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          elements: {
            line: {
              tension: 0.000001
            },
            point: {
              radius: 5
            }
          },
          legend: {
            display: false,
          },

        }
      });
    },
  },
};
</script>
 
